import { motion } from "framer-motion";
import { Bookmark, X } from "lucide-react";

export const SignUpNudge = ({ onJoin, onSignIn, onDismiss }) => (
  <motion.div
    data-testid="signup-nudge"
    role="status"
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35, ease: "easeOut" }}
    className="relative mt-3 w-full md:absolute md:mt-0 md:bottom-16 md:right-5 md:z-[15] md:w-[290px] bg-[#0A0A0F]/95 backdrop-blur-md border border-white/15 rounded-sm p-4 shadow-2xl"
  >
    <button
      data-testid="signup-nudge-close"
      onClick={onDismiss}
      aria-label="Close"
      className="absolute top-2 right-2 text-zinc-500 hover:text-white transition-colors"
    >
      <X className="w-4 h-4" />
    </button>
    <div className="flex items-start gap-3 pr-4">
      <Bookmark className="w-5 h-5 text-[#FF2A2A] shrink-0 mt-0.5" strokeWidth={2.5} />
      <div>
        <p className="font-semibold text-white leading-snug">Sign up free to keep your place</p>
        <p className="text-xs text-zinc-400 mt-1">Pick up right here on any device. No card needed.</p>
      </div>
    </div>
    <div className="mt-4 flex items-center gap-2">
      <button
        data-testid="signup-nudge-join"
        onClick={onJoin}
        className="flex-1 bg-[#FF2A2A] hover:bg-[#FF4D4D] text-white text-sm font-semibold px-4 py-2 rounded-sm transition-colors"
      >
        Join Free
      </button>
      <button
        data-testid="signup-nudge-dismiss"
        onClick={onDismiss}
        className="text-sm text-zinc-300 hover:text-white border border-white/20 hover:bg-white/10 px-4 py-2 rounded-sm transition-colors"
      >
        Not now
      </button>
    </div>
    <button
      data-testid="signup-nudge-signin"
      onClick={onSignIn}
      className="mt-3 text-xs text-zinc-500 hover:text-white transition-colors"
    >
      Already a member? Sign in
    </button>
  </motion.div>
);
